__turbopack_context__.v({
  "root": "text-link-module-scss-module__v8xrNa__root",
});
